import React from 'react';
import './NoMatch.css';

class Work extends React.Component {
  render() {
    return (
      <div className="NoMatch">
        <h1>No Page Found</h1>
        <p>Navigate to <a className="link" href="/">Home</a></p>
      </div>
    );
  }
}

export default Work;



// WEBPACK FOOTER //
// ./src/Pages/NoMatch.js